import * as actionTypes from "./actionTypes";

const initialState = {
  loading: false,
  createVendorLoading: false,
  error: null,
  orderDetails: {
    columns: [],
    headers: "",
    dataSource: [],
    totalCars: 0
  },
  cityData: {
    loading: false,
    cityList: []
  },
  vendorDetails: [],
  dateFilter: null,
  searchText: "",
  toShowAddVendor: null,
  pagination: { pageSize: 20, currentPage: 1 }
};

const fetchTableDataStart = (state) => ({
  ...state,
  loading: true
});

const fetchTableDataSuccess = (state, action) => ({
  ...state,
  loading: false,
  orderDetails: {
    columns: action.data.columns,
    headers: action.data.headerText,
    dataSource: action.data.dataSource,
    totalCars: action.data.totalCars
  },
  pagination: {
    ...state.pagination,
    pageSize: action.data.pageSize
  },
  toShowAddVendor: action.data.toShowAddVendor
});
const fetchTableDataFail = (state) => ({
  ...state,
  loading: false
});
const setPageSize = (state, action) => {
  const {
    orderDetails: { totalCars },
    pagination: { currentPage }
  } = state;
  const lastPage = totalCars / action.data;

  return {
    ...state,
    pagination: {
      ...state.pagination,
      pageSize: action.data,
      currentPage: lastPage > currentPage ? currentPage : Math.ceil(lastPage)
    }
  };
};
const setSearchInput = (state, action) => ({
  ...state,
  searchText: action.data,
  pagination: {
    ...state.pagination,
    currentPage: 1
  }
});
const setCurrentPage = (state, action) => ({
  ...state,
  pagination: {
    ...state.pagination,
    currentPage: action.data
  }
});

const createVendorStart = (state) => ({
  ...state,
  createVendorLoading: true
});
const createVendorSuccess = (state) => ({
  ...state,
  createVendorLoading: false,
  error: null
});
const createVendorFail = (state, action) => ({
  ...state,
  createVendorLoading: false,
  error: action.err.status
});

const setVendorDetails = (state, action) => ({
  ...state,
  vendorDetails: action.data
});

const setVendorDate = (state, action) => ({
  ...state,
  dateFilter: action.date,
  pagination: {
    ...state.pagination,
    currentPage: 1
  }
});

const setCityDataStart = (state) => ({
  ...state,
  cityData: {
    loading: true,
    cityList: []
  }
});

const setCityDataSuccess = (state, action) => ({
  ...state,
  cityData: {
    loading: false,
    cityList: action.data
  }
});

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_VENDOR_DATA_TABLE_START:
      return fetchTableDataStart(state, action);
    case actionTypes.GET_VENDOR_DATA_TABLE_SUCCESS:
      return fetchTableDataSuccess(state, action);
    case actionTypes.GET_VENDOR_DATA_TABLE_FAIL:
      return fetchTableDataFail(state, action);
    case actionTypes.SET_VENDOR_SEARCH_INPUT:
      return setSearchInput(state, action);
    case actionTypes.SET_VENDOR_PAGE_SIZE:
      return setPageSize(state, action);
    case actionTypes.SET_VENDOR_CURRENT_PAGE:
      return setCurrentPage(state, action);
    case actionTypes.CREATE_VENDOR_START:
      return createVendorStart(state, action);
    case actionTypes.CREATE_VENDOR_SUCCESS:
      return createVendorSuccess(state, action);
    case actionTypes.CREATE_VENDOR_FAIL:
      return createVendorFail(state, action);
    case actionTypes.SET_VENDOR_DETAILS:
      return setVendorDetails(state, action);
    case actionTypes.SET_VENDOR_DATE:
      return setVendorDate(state, action);
    case actionTypes.GET_CITY_START:
      return setCityDataStart(state, action);
    case actionTypes.GET_CITY_SUCCESS:
      return setCityDataSuccess(state, action);
    default:
      return state;
  }
};

export default reducer;
